<div class="example-story">
  <h2>{{ name }}</h2>
  <div class="example-story__canvas" role="presentation">
    <ng-content></ng-content>
  </div>
</div>
